import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'propTypes'
import { cx } from '@emotion/css'
import { colors } from '@offerzen/pinata-shame'
import CaretDownIcon from '@offerzen/zenicon/CaretDownIcon'
import AccessibleIcon from '../AccessibleIcon'

import styles from './styles'

const NavDropdown = ({ className, label, children }) => {
  const [open, setOpen] = useState(false)
  const node = useRef()

  useEffect(() => {
    const handleClosingClick = e => {
      if (node.current.contains(e.target)) return
      setOpen(false)
    }

    if (open) {
      document.addEventListener('mousedown', handleClosingClick)
    } else {
      document.removeEventListener('mousedown', handleClosingClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleClosingClick)
    }
  }, [open])

  return (
    <div className={cx(styles.wrapper, className)} ref={node}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-haspopup="true"
        aria-expanded={open}
        className={cx(styles.trigger, open && styles.triggerOpen)}>
        <span>{label}</span>
        {/* Bring the caret change when we remove the rails navbar */}
        {/* <AccessibleIcon icon={open ? CaretUpIcon : CaretDownIcon} size={16} color={colors.white} /> */}
        <div className={styles.icon}>
          <AccessibleIcon icon={CaretDownIcon} size={16} color={colors.white} />
        </div>
      </button>

      <If condition={open}>
        <ul role="menu" className={styles.body}>
          {React.Children.map(children, child => {
            if (!child) return undefined

            return React.cloneElement(child, {
              onClick: () => {
                if (child.props.onClick) child.props.onClick()
                setOpen(false)
              },
            })
          })}
        </ul>
      </If>
    </div>
  )
}

NavDropdown.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
}

export default NavDropdown
